import { useMutation } from "react-query";
import riskAssessmentHistoryService from "../../services/riskAssessmentHistoryService";

const useShareRiskAssessmentHistory = () =>
  useMutation(riskAssessmentHistoryService.shareRiskAssessmentHistory);

export default useShareRiskAssessmentHistory;